/**
 * @Author: 左建
 * @Date: 2022/9/2 14:02
 * @LastEditTime: 2022/9/2 14:02
 * @Description: 平台相关配置
*/
const { protocol, hostname, pathname, origin } = window.location
const realOrigin = process.env.NODE_ENV === "development" ? protocol + "//" + hostname : origin
const realDomain = realOrigin + (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname)
export const DOMAIN = realDomain.replace(/(\/mobile-exam.html)|(\/mobile-exam)/g, "")

export const HOME_PAGE_MAP = Object.freeze({
    kaoshi: {
        path: "/home-exam",
        hostKey: "kaoshi",
        domain: DOMAIN,
        // domain: "http://kaoshi.cqvip.com",
        title: "培训考试平台"
    },
    yixue: {
        path: "/home-medicine",
        hostKey: "yixue",
        domain: DOMAIN,
        // domain: "http://yixue.cqvip.com",
        title: "医学培训考试服务平台"
    },
    jigou: {
        path: "/home-organization",
        hostKey: "jigou",
        domain: DOMAIN,
        // domain: "http://yixue.cqvip.com",
        title: "机构定制"
    },
    hangye: {
        path: "/home-business",
        hostKey: "hangye",
        domain: DOMAIN,
        // domain: "http://hangye.cqvip.com/hangye",
        title: "行业定制"
    },
    default: {
        path: "/home-business",
        hostKey: "default",
        domain: DOMAIN,
        // domain: "http://hangye.cqvip.com/hangye",
        title: "行业定制"
    },

})

/** 用户端（注意是用户端，而非管理端）各个模块的映射（通过后台配置的code来映射
 * 所以不要轻易去修改后台管理中模块的code值）别问为什么这么做，问就是强行兼容之前版本迭代的屎山
 */
export const codeMapModules = Object.freeze({
    "-100": {
        text: "题库",
        enName: "question-lib-module"
    },
    "-200": {
        text: "考试",
        enName: "exam-module"
    },
    "-300": {
        text: "课程",
        enName: "course-module"
    },
    "-400": {
        text: "问卷",
        enName: "questionnaire-module"
    },
    "-500": {
        text: "首页",
        enName: "home-module"
    },
    "2": {
        text: "个人信息",
        enName: "profile-module"
    },
    "3": {
        text: "我的收藏",
        enName: "my-collect-module"
    },
    "4": {
        text: "我的足迹",
        enName: "my-track-module"
    },
    "5": {
        text: "我的问卷",
        enName: "my-questionnaire-module"
    },
    "6": {
        text: "我的会员",
        enName: "my-member-module"
    },
    "7": {
        text: "我的课程",
        enName: "my-course-module"
    },
    "8": {
        text: "我的考试",
        enName: "my-exam-module"
    },
})
